/* Vision Support Bites on the oc-ph-hw-v1 page layout. Jar packs are Kaching quantity breaks on one
   variant: the deal is read live through the Kaching SDK, each pack is added with Kaching's own line token,
   and the bar's selling plan carries the subscription. Unlocked gifts are separate $0 lines (Free gifts
   automatic discount). */
(() => {
  'use strict';
  const root = document.querySelector('[data-oc-hw-native]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-hw-config]').textContent);
  const decoder = document.createElement('textarea');
  Object.keys(cfg.strings).forEach(key => {decoder.innerHTML=cfg.strings[key];cfg.strings[key]=decoder.value;});
  const params = new URLSearchParams(location.search);
  const form = root.querySelector('[data-hw-purchase]');
  const button = form.querySelector('[data-hw-add]');
  const label = button.querySelector('[data-hw-add-label]');
  const offerRoot = root.querySelector('[data-hw-offers]');
  const status = root.querySelector('[data-hw-status]');
  const dose = root.querySelector('[data-hw-dose]');
  const toggle = root.querySelector('[data-hw-mode]');
  const radios = [...root.querySelectorAll('[name="oc-hw-pack"]')];
  let mode = 'subscription', busy = false, uncertain = false;
  const dealError = 'This offer could not be loaded. Refresh the page and try again.';

  // Deal bars from the section (current Kaching deal), replaced by the live deal once the SDK loads.
  let deal = cfg.deal;
  const rate = cfg.currency === cfg.baseCurrency ? 1 : Number(window.Shopify?.currency?.active === cfg.currency && window.Shopify.currency.rate);
  const ratesOk = Number.isFinite(rate) && rate > 0;
  const startDealEngine = async () => {
    const app = document.getElementById('kaching-bundles-config');
    const settings = app && JSON.parse(app.textContent);
    if (!settings?.storefrontAccessToken) return;
    await import(cfg.bundleSdk);
    const widget = document.createElement('kaching-bundle-component');
    widget.setAttribute('aria-hidden','true');
    widget.setAttribute('inert','');
    widget.hidden = true;
    for (const [key,value] of Object.entries({
      'shop-domain':settings.shopifyDomain,
      'storefront-token':settings.storefrontAccessToken,
      'product-id':String(cfg.productId),
      'deal-block-id':cfg.deal.blockId,
      'selected-variant-id':String(cfg.variant.id),
      country:cfg.country,language:'EN'
    })) widget.setAttribute(key,value);
    const loaded = new Promise((resolve,reject) => {
      const timer = setTimeout(()=>reject(new Error(dealError)),15000);
      widget.addEventListener('loaded',()=>{clearTimeout(timer);resolve();},{once:true});
    });
    root.append(widget);
    await loaded;
    const live = JSON.parse(widget.querySelector('kaching-bundles-block')?.getAttribute('deal-block') || 'null');
    const bars = {};
    for (const bar of live?.dealBars || []) {
      if (bar.dealBarType !== 'quantity-break' || bar.discountType !== 'specific' || ![1,2,3].includes(bar.quantity)) continue;
      bars[bar.quantity] = {id:bar.id, value:Number(bar.discountValue), plan:Number(String(bar.sellingPlanGid||'').split('/').pop())||null};
    }
    if (!live?.nanoId || !live?.versionId || Object.keys(bars).length !== 3) throw new Error(dealError);
    deal = {...cfg.deal, nanoId:live.nanoId, versionId:live.versionId, bars};
    widget.remove();
    if(params.get('oc_qa')==='1')root.dataset.hwDeal=JSON.stringify(deal);
    render();
  };

  const formatter = new Intl.NumberFormat('en-US', {style:'currency',currency:cfg.currency});
  const money = cents => formatter.format(cents / 100);
  const reference = cfg.variant.compareAt > cfg.variant.price ? cfg.variant.compareAt : cfg.variant.price;
  const planFor = jars => cfg.plans.find(p => p.id === deal.bars[jars]?.plan);
  // Kaching prices a pack at the bar's fixed amount (shop currency, converted at the market rate);
  // the bar's selling plan then takes its percentage off that amount. Checked against real carts.
  const priceOnce = jars => Math.round(deal.bars[jars].value * rate * 100);
  const priceSub = jars => Math.round(priceOnce(jars) * (1 - (planFor(jars)?.adjustment || 0) / 100));
  const amountFor = jars => mode === 'once' ? priceOnce(jars) : priceSub(jars);
  root.querySelectorAll('.product-info .review-product-title + .product-price').forEach(value => {
    if (ratesOk) value.textContent = money(priceOnce(1));
  });
  const giftCurrency = window.Shopify?.currency;
  const giftRate = cfg.currency === 'USD' ? 1 : Number(giftCurrency?.rate);
  const giftFormatter = new Intl.NumberFormat('en-' + cfg.country, {
    style: 'currency', currency: cfg.currency, currencyDisplay: 'narrowSymbol'
  });
  if (cfg.baseCurrency === 'USD' && giftCurrency?.active === cfg.currency && Number.isFinite(giftRate) && giftRate > 0) {
    root.querySelectorAll('[data-hw-gift-value]').forEach(value => {
      const amount = Math.round(Number(value.dataset.hwGiftValue) * giftRate);
      value.textContent = giftFormatter.format(amount / 100);
      value.setAttribute('aria-label', value.textContent + ' ' + cfg.currency + ' gift value');
      value.hidden = false;
    });
  }
  const endpoint = suffix => cfg.root.replace(/\/$/,'') + '/cart/' + suffix;
  const cartEndpoint = cfg.root.replace(/\/$/,'') + '/cart.js';
  const selected = () => Number(radios.find(r => r.checked)?.value) || 0;
  const announce = message => { status.textContent = message; };
  const cartCount = cart => document.querySelectorAll('[data-hw-cart-count]').forEach(n => {const value=String(cart.item_count);if(n.textContent!==value)n.textContent=value;});
  const openCart = () => {
    if (window.ocVisionCart) return window.ocVisionCart.open();
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.open) drawer.open();
    else location.assign(cfg.root.replace(/\/$/,'') + '/cart');
  };
  const loadCart = async () => {
    const response = await fetch(cartEndpoint, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error(cfg.strings.cartCheck);
    return response.json();
  };
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate,({cartData}={})=>{
      if(Number.isFinite(cartData?.item_count))cartCount(cartData);
      else loadCart().then(cartCount).catch(()=>{});
    });
  }
  const nativeDrawer=document.querySelector('cart-drawer');
  if(nativeDrawer){
    // Cart add-ons are one-time purchases. The main product keeps its selling plan.
    const syncOneTimeUpsells=()=>{
      nativeDrawer.querySelectorAll('cart-drawer-upsell product-form form').forEach(upsellForm=>{
        upsellForm.querySelectorAll('[name="selling_plan"]').forEach(input=>{
          if(input.value)input.value='';
          if(!input.disabled)input.disabled=true;
        });
        if(upsellForm.dataset.ocHwOneTime==='true')return;
        upsellForm.dataset.ocHwOneTime='true';
        upsellForm.addEventListener('formdata',event=>event.formData.delete('selling_plan'));
      });
    };
    const syncDrawerCount=()=>{
      syncOneTimeUpsells();
      const quantities=[...nativeDrawer.querySelectorAll('input[name="updates[]"]')];
      if(nativeDrawer.classList.contains('is-empty'))cartCount({item_count:0});
      else if(quantities.length)cartCount({item_count:quantities.reduce((n,input)=>n+(Number(input.value)||0),0)});
    };
    nativeDrawer.addEventListener('click',event=>{if(event.target.closest('cart-drawer-upsell .upsell__add-btn'))syncOneTimeUpsells();},true);
    nativeDrawer.addEventListener('submit',event=>{if(event.target.closest('cart-drawer-upsell'))syncOneTimeUpsells();},true);
    new MutationObserver(syncDrawerCount).observe(nativeDrawer,{subtree:true,childList:true,attributes:true,attributeFilter:['class','value','disabled']});
    syncDrawerCount();
  }
  const post = async (path,body) => {
    const response = await fetch(endpoint(path), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    return data;
  };
  function marketUrl() {
    const url = new URL(location.href);
    url.searchParams.set('view',cfg.view);
    url.searchParams.delete('country');
    return url.pathname + url.search;
  }
  const marketForm = document.getElementById('oc-hw-market');
  const mobileMenu = document.querySelector('.oc-hw-mobile-nav');
  const mobileMarket = document.querySelector('[data-hw-mobile-market]');
  const desktopMarket = document.querySelector('[data-hw-desktop-market]');
  const mobileHeader = matchMedia('(max-width: 989px)');
  const placeMarket = () => {
    const destination = mobileHeader.matches ? mobileMarket : desktopMarket;
    if (marketForm && destination && marketForm.parentElement !== destination) destination.append(marketForm);
    if (!mobileHeader.matches && mobileMenu) mobileMenu.open = false;
  };
  placeMarket();
  mobileHeader.addEventListener('change',placeMarket);
  mobileMenu?.addEventListener('keydown',event => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
    }
  });
  const countrySelect = marketForm?.querySelector('[data-hw-country]');
  countrySelect?.addEventListener('change', () => {
    marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
    marketForm.submit();
  });
  if (cfg.requiredCountry && cfg.country !== cfg.requiredCountry && !window.Shopify?.designMode) {
    button.disabled = true;
    if (countrySelect && [...countrySelect.options].some(o => o.value === cfg.requiredCountry)) {
      countrySelect.value = cfg.requiredCountry;
      marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
      marketForm.submit();
    } else announce('This country is not available in the store.');
    return;
  }
  if (cfg.country !== 'US') {
    [...dose.options].forEach((option,i) => {option.textContent=['Up to 6.5 kg: 2 chews','6.5 to 16 kg: 3 chews','Over 16 kg: 4 chews'][i];});
  }
  function render() {
    const ready = ratesOk && !!deal?.bars?.[1];
    radios.forEach(radio => {
      const jars = Number(radio.value);
      const p = planFor(jars);
      const available = ready && cfg.variant.available && !!deal.bars[jars] && (mode === 'once' || !!p);
      const amount = available ? amountFor(jars) : 0;
      const bar = radio.closest('[data-oc-bottles]');
      bar.classList.toggle('kaching-bundles__bar--selected',radio.checked);
      radio.disabled = !available || busy || uncertain;
      if (!available) return;
      const save = Math.round((1-amount/(reference*jars))*100);
      bar.querySelector('[data-hw-save]').textContent = save>0 ? `You save ${save}%` : '';
      const each = bar.querySelector('[data-hw-each]');
      each.replaceChildren(document.createTextNode(money(amount/jars)+' '));
      const unit = document.createElement('span');unit.className='kaching-bundles__bar-price__unit-label';unit.textContent='each';each.append(unit);
      each.setAttribute('aria-label',money(amount/jars)+' each');
      bar.querySelector('[data-hw-reference]').textContent=money(reference);
      const total=bar.querySelector('[data-hw-total]');if(total)total.textContent='Total: '+money(amount);
    });
    const jars=selected(),p=planFor(jars),amount=ready&&jars?amountFor(jars):0;
    form.querySelector('[data-hw-variant]').value=String(cfg.variant.id);
    form.querySelector('[name="quantity"]').value=String(jars||1);
    const input=form.querySelector('[data-hw-plan]');input.disabled=mode==='once';input.value=mode==='once'?'':String(p?.id || '');
    toggle.textContent=mode==='subscription'?cfg.strings.once:cfg.strings.subscribe;
    toggle.setAttribute('aria-pressed',String(mode==='once'));
    const renewal=root.querySelector('[data-hw-renewal]');
    const lasts=Math.floor(cfg.chewsPerJar/Number(dose.value||2));
    if(ready&&jars)renewal.textContent=(mode==='once'?`One-time purchase: ${money(amount)}. No recurring charges.`:`Subscribe & save: ${money(amount)} today, then delivered every month. ${cfg.strings.cancel}`)+` One jar lasts about ${lasts} days at this serving. Prices in ${cfg.currency}.`;
    root.querySelectorAll('[data-hw-gift]').forEach(tile => {
      const minimum=Number(tile.dataset.hwGift),open=jars>=minimum,key=tile.dataset.hwGiftKey;
      tile.classList.toggle('oculabs-gift--locked',!open);
      tile.dataset.ocGiftLocked=String(!open);
      tile.setAttribute('aria-label',tile.querySelector('.kaching-bundles__progressive-gifts__gift__title').textContent+(open?'. Included with your first order':`. Unlocks with ${minimum} jars`));
      tile.querySelector('.oculabs-gift-note').textContent=open?(tile.dataset.hwGiftNote||({'cloudy-eye-guide':'Digital guide','mystery-gift':'A gift for your dog'})[key]||''):`Unlocks with ${minimum} jars`;
    });
    button.disabled=busy||uncertain||!ready||!cfg.variant.available||!jars||(mode==='subscription'&&!p);
    toggle.disabled=busy||uncertain;dose.disabled=busy||uncertain;
    label.textContent=busy?cfg.strings.adding:cfg.strings.add;
    offerRoot.style.visibility='visible';
    root.dataset.hwMode=mode;root.dataset.hwReady=String(!button.disabled);
    if(!ratesOk)announce('Prices for your currency could not be loaded. Refresh the page or switch country.');
  }
  radios.forEach(r => r.addEventListener('change',render));
  dose.addEventListener('change',render);
  toggle.addEventListener('click',() => {mode=mode==='subscription'?'once':'subscription';render();});
  root.querySelectorAll('[data-hw-gift]').forEach(tile => {
    const choose=() => {if(busy||uncertain)return;const r=radios.find(x=>Number(x.value)===Number(tile.dataset.hwGift));if(r&&!r.disabled){r.checked=true;render();}};
    tile.addEventListener('click',choose);tile.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();choose();}});
  });
  function lineProperties() {
    const properties={_oc_vision_page:cfg.pageVersion,_oc_daily_chews:String(dose.value),_oc_market:cfg.country};
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']){const value=params.get(key);if(value)properties['_'+key]=value.slice(0,150);}
    if(params.get('oc_qa')==='1')properties._oc_qa=cfg.pageVersion;
    return properties;
  }
  function kachingToken(jars,p) {
    const token={deal:deal.nanoId,pp:cfg.productId,main:true,v:deal.versionId,bid:deal.bars[jars].id};
    if(p)token.sellingPlan={id:p.id,priceAdjustment:{type:'percentage',value:p.adjustment}};
    return JSON.stringify(token);
  }
  const newGroup=()=>(window.crypto&&typeof crypto.randomUUID==='function')?crypto.randomUUID():Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
  function bundleItems(jars,p,group,base) {
    const properties={...base,_oc_vision_group:group,__kaching_bundles:kachingToken(jars,p)};
    const items=[{id:cfg.variant.id,quantity:jars,properties}];
    if(p)items[0].selling_plan=p.id;
    cfg.gifts.filter(g=>jars>=g.min).forEach(g=>items.push({id:g.variantId,quantity:1,properties:{...(g.props||{}),_gift:'true',_oc_vision_gift:g.key,_oc_vision_group:group}}));
    return items;
  }
  // The cart drawer (the store-wide oc-cart.js) switches a pack between 1, 2 and 3 jars with these, and shows a new
  // pack's price at once with price() while Shopify catches up.
  window.ocVision={
    variantId:cfg.variant.id,gifts:cfg.gifts,giftSet:cfg.giftSet||'resilia',maxJars:3,
    bundleItems:(jars,subscribe,base)=>{const p=subscribe?planFor(jars):null;if(!deal?.bars?.[jars]||(subscribe&&!p))return null;return bundleItems(jars,p,newGroup(),base||lineProperties());},
    price:(jars,subscribe)=>ratesOk&&deal?.bars?.[jars]?(subscribe?priceSub(jars):priceOnce(jars)):null,
    cartCount
  };
  async function refreshDrawer(data,cart) {
    cartCount(cart);
    if(window.ocVisionCart)return window.ocVisionCart.open(cart);
    const drawer=document.querySelector('cart-drawer');
    if(drawer?.renderContents&&data?.sections){drawer.classList.toggle('is-empty',cart.item_count===0);drawer.renderContents(data);}
    else openCart();
  }
  form.addEventListener('submit',async event => {
    event.preventDefault();if(button.disabled||busy||uncertain)return;
    busy=true;announce('');render();
    const jars=selected(),p=mode==='once'?null:planFor(jars),group=newGroup();
    const items=bundleItems(jars,p,group,lineProperties());
    const gifts=cfg.gifts.filter(g=>jars>=g.min);
    if(params.get('oc_qa')==='1')root.dataset.hwSubmitItems=JSON.stringify(items);
    let submitted=false,added=false;
    const inGroup=line=>line.properties?._oc_vision_group===group;
    const isMain=line=>inGroup(line)&&line.variant_id===cfg.variant.id;
    const expected=p?p.price:cfg.variant.price;
    try{
      const baseline=await loadCart();
      if(baseline.currency!==cfg.currency)throw new Error('Your currency changed. Refresh the page before adding this supply.');
      const drawer=document.querySelector('cart-drawer');drawer?.setActiveElement?.(button);
      const sections=window.ocVisionCart?[]:drawer?.getSectionsToRender?.().map(x=>x.id)||['cart-drawer','cart-icon-bubble'];
      const withSections=body=>sections.length?{...body,sections,sections_url:location.pathname}:body;
      submitted=true;
      const response=await post('add.js',withSections({items}));
      added=true;
      const cart=await loadCart();
      const main=cart.items.find(isMain);
      const planOk=String(main?.selling_plan_allocation?.selling_plan?.id||'')===String(p?.id||'');
      if(cart.currency!==cfg.currency||!main||main.quantity!==jars||!planOk||main.original_price!==expected)throw new Error(cfg.strings.cartCheck);
      const giftLines=cart.items.filter(l=>inGroup(l)&&l.variant_id!==cfg.variant.id);
      if(giftLines.length!==gifts.length||giftLines.some(l=>l.final_line_price!==0||l.selling_plan_allocation)){
        // Remove this pack's lines by position in a fresh cart: Kaching rewrites same-deal lines, so keys shift.
        let rollback=null;
        for(let guard=0;guard<12;guard++){const fresh=await loadCart();const index=fresh.items.findIndex(inGroup);if(index<0)break;rollback=await post('change.js',withSections({line:index+1,quantity:0}));}
        const restored=await loadCart();
        if(restored.items.some(inGroup))throw new Error(cfg.strings.cartCheck);
        await refreshDrawer(rollback,restored);added=false;submitted=false;
        throw new Error('The free gifts could not be applied. Nothing was added. Please refresh and try again.');
      }
      await refreshDrawer(response,cart);announce(cfg.strings.added);
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())window.dataLayer?.push({event:'oc_vision_add_to_cart',page:cfg.pageVersion,jars,plan_type:p?'subscription':'one-time',currency:cfg.currency,qa:params.get('oc_qa')==='1'});
    }catch(error){
      // A timeout can come after Shopify accepted the items. Check the saved cart before allowing another
      // click, so a retry cannot double an order.
      if(submitted){
        try{const cart=await loadCart();added=added||cart.items.some(inGroup);cartCount(cart);uncertain=added&&!cart.items.some(isMain);}
        catch{uncertain=true;}
      }
      announce(uncertain?cfg.strings.cartCheck:error instanceof TypeError?cfg.strings.error:error.message||cfg.strings.error);
      if(uncertain||added){const link=document.createElement('a');link.href=cfg.root.replace(/\/$/,'')+'/cart';link.textContent=' View cart';status.append(link);}
    }finally{busy=false;render();}
  });
  document.querySelectorAll('[data-hw-cart]').forEach(button=>button.addEventListener('click',openCart));
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
  const loadImage=img=>{if(img?.dataset.src){img.src=img.dataset.src;if(img.dataset.srcset)img.srcset=img.dataset.srcset;delete img.dataset.src;delete img.dataset.srcset;}};
  const formula=root.querySelector('#oc-hw-formula'),feeding=root.querySelector('#oc-hw-feeding'),zoom=root.querySelector('#oc-hw-zoom');
  // Safari before iOS 15.4 has no <dialog>: hide these three pop-ups until opened and open/close them by hand there.
  [formula,feeding,zoom].forEach(d=>{if(!d||typeof d.showModal==='function')return;if(!document.getElementById('oc-dialog-fallback')){const st=document.createElement('style');st.id='oc-dialog-fallback';st.textContent='#oc-hw-formula:not([open]),#oc-hw-feeding:not([open]),#oc-hw-zoom:not([open]){display:none}#oc-hw-formula[open],#oc-hw-feeding[open],#oc-hw-zoom[open]{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2147483000;margin:0;max-height:88vh;overflow:auto;box-shadow:0 0 0 100vmax rgba(11,30,57,.7)}';document.head.appendChild(st);}d.showModal=()=>d.setAttribute('open','');d.close=()=>d.removeAttribute('open');});
  const formulaArtwork=root.querySelector('.shop-main-image[data-media-id="oc-vision-10"]')||root.querySelectorAll('.shop-main-image')[3];
  const showFormula=()=>{const img=formula.querySelector('[data-hw-formula-image]');img.src=formulaArtwork.dataset.zoomSrc||formulaArtwork.dataset.src||formulaArtwork.src;img.alt=formulaArtwork.alt;};
  root.querySelectorAll('[data-hw-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=button.dataset.hwOpen==='formula'?formula:feeding;if(dialog===formula)showFormula();else dialog.querySelectorAll('img').forEach(loadImage);dialog.showModal();dialog.querySelector('[data-hw-close]').focus();}));
  [formula,feeding,zoom].forEach(dialog=>{dialog.querySelector('[data-hw-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});});
  root.querySelector('.shop-main-image-wrapper')?.addEventListener('click',e=>{if(e.target.closest('button,a'))return;const active=root.querySelector('.shop-main-image.active');if(!active)return;const img=zoom.querySelector('img');img.src=active.dataset.zoomSrc||active.src;img.alt=active.alt;zoom.showModal();});
  // Keep FAQ paragraphs intact and expose the existing accordion to keyboards.
  root.querySelectorAll('.faq-question').forEach(question=>{const item=question.closest('.faq-item');question.tabIndex=0;question.setAttribute('role','button');const syncExpanded=()=>{const expanded=String(item.classList.contains('active'));if(question.getAttribute('aria-expanded')!==expanded)question.setAttribute('aria-expanded',expanded);};const faqObserver=new MutationObserver(syncExpanded);faqObserver.observe(item,{attributes:true,attributeFilter:['class']});faqObserver.observe(question,{attributes:true,attributeFilter:['aria-expanded']});syncExpanded();question.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();question.click();}});});
  root.querySelectorAll('.shop-thumbnail').forEach((thumb,i)=>{thumb.tabIndex=0;thumb.setAttribute('role','button');thumb.setAttribute('aria-label',`View product image ${i+1}`);thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();thumb.click();}});});
  const gallerySurface=root.querySelector('.shop-main-image-wrapper');
  if(gallerySurface){
    [-1,1].forEach(direction=>{
      const arrow=document.createElement('button');arrow.type='button';
      arrow.className='oc-hw-gallery-arrow '+(direction<0?'prev':'next');
      arrow.setAttribute('aria-label',direction<0?'Previous product image':'Next product image');
      arrow.textContent=direction<0?'‹':'›';
      arrow.addEventListener('click',()=>{
        const dots=[...root.querySelectorAll('.shop-dot')];
        const index=[...root.querySelectorAll('.shop-main-image')].findIndex(img=>img.classList.contains('active'));
        dots[(index+direction+dots.length)%dots.length]?.click();
      });
      gallerySurface.append(arrow);
    });
  }
  render();
  startDealEngine().catch(error=>{
    // The section's copy of the deal still works; only a later Kaching edit would make it stale.
    root.dataset.hwDealLive='false';if(params.get('oc_qa')==='1')root.dataset.hwDealError=String(error?.message||error);
  });
})();
